module.exports = __webpack_public_path__ + "img/tool-1.3e0fb77c.png";